<template>
    <div class="ld-pagination">
        <button :class="{'disabled': currentPage === 1}" class="previous-button" @click="previous">
            <chevron-left-icon class="icon"></chevron-left-icon>
        </button>

        <div class="pagination-buttons">
            <button
                v-if="numberPages > 10"
                :class="{'active': currentPage === 1}"
                @click="setCurrentPage"
            >1</button>

            <button v-if="numberPages > 10 && currentPage >= 7" class="more">...</button>

            <button
                :class="{'active animated bounceIn': page === currentPage}"
                :key="index"
                v-for="(page, index) in pages"
                @click="setCurrentPage"
            >{{ page }}</button>

            <button v-if="numberPages > 10 && lastPage < (numberPages - 1)" class="more">...</button>

            <button
                v-if="numberPages > 10"
                :class="{'active': numberPages === currentPage}"
                @click="setCurrentPage"
            >{{numberPages}}</button>
        </div>

        <button
            :class="{'disabled': currentPage === numberPages}"
            class="next-button"
            @click="next"
        >
            <chevron-right-icon class="icon"></chevron-right-icon>
        </button>
    </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from "vue-feather-icons";

export default {
    name: "LdPagination",
    components: {
        ChevronLeftIcon,
        ChevronRightIcon
    },
    props: {
        numberPages: {
            type: Number,
            required: true,
            default: 1,
        },
        currentPage: {
            type: Number,
            required: true,
            default: 1
        }
    },
    computed: {
        firstPage() {
            let firstPage = 0;

            if (this.currentPage >= 7 && this.numberPages > 11) {
                if (this.currentPage >= this.numberPages - 4) {
                    firstPage = this.numberPages - 8;
                } else {
                    firstPage = this.currentPage - 3;
                }
            } else if (this.currentPage >= 7 && this.numberPages <= 11) {
                firstPage = this.numberPages - 8;
            } else {
                firstPage = 2;
            }

            return firstPage;
        },
        lastPage() {
            let lastPage = 0;

            if (this.currentPage >= 7 && this.numberPages > 11) {
                if (this.currentPage <= this.numberPages - 6) {
                    lastPage = this.currentPage + 3;
                } else {
                    lastPage = this.numberPages - 1;
                }
            } else if (this.currentPage >= 7 && this.numberPages <= 11) {
                lastPage = this.numberPages - 1;
            } else {
                lastPage = 9;
            }

            return lastPage;
        },
        pages() {
            const pages = [];

            if (this.numberPages <= 10) {
                for (let page = 1; page <= this.numberPages; page++) {
                    pages.push(page);
                }
            } else {
                for (let page = this.firstPage; page <= this.lastPage; page++) {
                    pages.push(page);
                }
            }

            return pages;
        }
    },
    methods: {
        setCurrentPage(event) {
            const currentPage = parseInt(event.target.innerText);
            this.$emit("update:currentPage", currentPage);
        },
        next() {

            if (this.currentPage < this.numberPages) {
                this.$emit("update:currentPage", this.currentPage + 1);
            }
        },
        previous() {
            if (this.currentPage > 1) {
                this.$emit("update:currentPage", this.currentPage - 1);
            }
        }
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/_variables.scss";

.ld-pagination {
    position: relative;
    display: flex;
    justify-content: center;

    .pagination-buttons {
        display: inline-block;
        background: #f0f0f0;
        border-radius: 4rem;
    }

    button {
        position: relative;
        width: 35px;
        height: 35px;
        background: transparent;
        border: none;
        border-radius: 5rem;
        font-family: "Montserrat", Helvetica, Arial, sans-serif;
        font-size: 0.8rem;
        font-weight: 700;
        color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &.more {
            pointer-events: none;
            cursor: pointer;

            &:hover {
                color: rgba(0, 0, 0, 0.5);
            }
        }

        &.active {
            width: 36px;
            height: 36px;
            color: #ffffff;
            cursor: default;
            pointer-events: none;
            background: $primary;
        }

        &:not(.active):hover {
            color: $primary;
        }

        &.next-button,
        &.previous-button {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f0f0f0;

            .icon {
                width: 1.2rem;
                color: rgba(0, 0, 0, 0.5);
            }

            &:hover {
                background: $primary;

                & .icon {
                    color: #ffffff;
                }
            }

            &.disabled {
                background: #f7f7f7 !important;
                cursor: default !important;
                pointer-events: none;

                & .icon {
                    color: #a6a6a6 !important;
                }
            }
        }

        &.next-button {
            margin-left: 4px;
        }

        &.previous-button {
            margin-right: 4px;
        }
    }
}
</style>
